import {Paper, PaperProps, styled} from "@mui/material";

export const HeaderContainer = styled((props: PaperProps) => (
    <Paper elevation={2} square {...props}/>
))(() => ({
    position: 'fixed',
    width: '100%',
    zIndex: 100,
    padding: '8px 26px 8px 38px',
    height: '60px',
    minWidth: '375px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    '& .logo': {
        height: '3rem',
    },
}));

export const HeaderContainerSlim = styled(HeaderContainer)(() => ({
    padding: '0',
    '& .MuiButton-root': {
        minWidth: '60px',
        paddingLeft: '0',
        paddingRight: '0',
    }
}))

export const BurgerAndLogoBlock = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center'
}))